import React, { FC } from 'react';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import SpecCheckPluginContainer from './components/pluginContainer';
import { SpecCheckProps } from './types/specCheck.types';
import { SpecCheckModel } from './models/specCheck.model';

const SpecCheck: FC<SpecCheckProps> = (props) => {
  const model = new SpecCheckModel(props);

  if (!model.embedId && !model.title) {
    return isEditorActive() ? <EmptyApiDataMessage componentName={model.componentName} /> : <></>;
  }

  return <SpecCheckPluginContainer model={model} />;
};

export default SpecCheck;
